import styled from 'styled-components';

interface FlagIconElementProps {
    small?: boolean;
}

export const PaymentMethodImageStyled = styled.img.attrs({
    role: 'presentation',
})<FlagIconElementProps>`
    min-height: ${(props) => (props.small ? `18px` : '24px')};
    width: ${(props) => (props.small ? `24px` : '34px')};
    vertical-align: bottom;
`;
